import { TOAST_TYPES, type ToastProps } from './SVToast';

const formatUserNames = (users: ToastProps['users']) => {
	const names = users?.map((user) => user.name).filter(Boolean) || [];
	if (names.length === 1) return names[0];
	if (names.length === 2) {
		return (
			<div>
				{names[0]} <span className="text-gray-500">and</span> {names[1]}
			</div>
		);
	}
	const last = names.pop();
	return (
		<div>
			{names.join(', ')} <span className="text-gray-500">and</span> {last}
		</div>
	);
};

const _SuccessToast = ({ content, users, user }: ToastProps) => {
	return (
		<div>
			<p className="text-sm font-medium text-gray-700">
				<span className="text-gray-500">{content + ' '} </span>
				{users?.length ? (
					<span className="font-semibold text-gray-900">{formatUserNames(users)}</span>
				) : user ? (
					<span className="font-semibold text-gray-900">{user.name}</span>
				) : null}
			</p>
		</div>
	);
};

const _AddToBoardToast = ({ title, content }: ToastProps) => {
	return (
		<div className="max-w-[150px]">
			<p className="line-clamp-2 text-sm font-medium text-gray-700">
				<span className="text-gray-500">{content} </span>
				<span className="font-semibold text-gray-900"> {title}</span>
			</p>
		</div>
	);
};

const _BoardCreatedToast = ({ title, isTeamBoard }: ToastProps) => {
	return (
		<div>
			<p className="line-clamp-2 text-sm font-medium text-gray-700">
				<span className="text-gray-500">{isTeamBoard ? ' Team Board' : ' Board'}</span>
				<span className="font-semibold text-gray-900"> {title}</span>
				<span className="text-gray-500"> created</span>
			</p>
		</div>
	);
};

const _BoardDeletedToast = ({ title, isTeamBoard }: ToastProps) => {
	return (
		<div>
			<p className="line-clamp-2 text-sm font-medium text-gray-700">
				<span className="text-gray-500">{isTeamBoard ? ' Team Board' : ' Board'}</span>
				<span className="font-semibold text-gray-900"> {title}</span>
				<span className="text-gray-500"> deleted</span>
			</p>
		</div>
	);
};

const _DefaultToast = ({ title, description }: ToastProps) => {
	return (
		<div className="line-clamp-2 flex flex-col">
			{title && <p className="text-sm font-medium text-gray-700">{title}</p>}
			{description && <p className="mt-1 text-xs text-gray-500">{description}</p>}
		</div>
	);
};

export default function ToastContent(props: ToastProps) {
	if (props.type === TOAST_TYPES.SUCCESS) {
		if (props.content && (props.users || props.user)) {
			return <_SuccessToast {...props} />;
		}
		return <_DefaultToast {...props} />;
	}

	if (props.type === TOAST_TYPES.ADD_TO_BOARD && props.title && props.content) {
		return <_AddToBoardToast {...props} />;
	}

	if (props.type === TOAST_TYPES.BOARD_CREATED && props.title) {
		return <_BoardCreatedToast {...props} />;
	}

	if (props.type === TOAST_TYPES.BOARD_DELETED && props.title) {
		return <_BoardDeletedToast {...props} />;
	}

	return <_DefaultToast {...props} />;
}
